export const structuredErrorResponseTypes = ["UniqueConstraintFailed", "InvalidData", "ConflictingEntity"] as const;
export type StructuredErrorResponseType = (typeof structuredErrorResponseTypes)[number];

export interface StructuredErrorResponse {
  type: StructuredErrorResponseType;
}

export interface UniqueConstraintError extends StructuredErrorResponse {
  type: "UniqueConstraintFailed";
  fields: string[];
}

export interface InvalidDataError extends StructuredErrorResponse {
  type: "InvalidData";
  fields: string[];
}

export interface ConflictingEntityError extends StructuredErrorResponse {
  type: "ConflictingEntity";
  entityIds: string[];
}

export type ApplicationError = UniqueConstraintError | InvalidDataError | ConflictingEntityError; // list all errors here

export interface DataErrorResponse {
  message: string;
  data: ApplicationError;
}

export function isUniqueConstraintError(error: ApplicationError | null | undefined): error is UniqueConstraintError {
  return error?.type === "UniqueConstraintFailed";
}

export function isInvalidDataError(error: ApplicationError | null | undefined): error is InvalidDataError {
  return error?.type === "InvalidData";
}

export function isConflictingEntityError(error: ApplicationError | null | undefined): error is ConflictingEntityError {
  return error?.type === "ConflictingEntity";
}
